import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';
import { usePageMeta } from '@/hooks/usePageMeta';
import { FAQ_GROUPS } from '@/mocks/faq';
import FaqHero from '@/pages/faq/components/FaqHero';
import FaqGroups from '@/pages/faq/components/FaqGroups';

export default function Faq() {
  const allFaq = useMemo(() => FAQ_GROUPS.flatMap((g) => g.items), []);

  const jsonLd = useMemo(
    () => [
      {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: '爆料大赛常见问题 - 赛程时间、报名投稿与评审规则解答',
        description:
          '爆料大赛常见问题解答，涵盖赛程时间与阶段划分、报名投稿与材料规范、投票权重与刷票处理、结果公示与奖项发放。',
        inLanguage: 'zh-CN',
      },
      {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首页', item: '/' },
          { '@type': 'ListItem', position: 2, name: '常见问题', item: '/faq' },
        ],
      },
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: allFaq.map((item) => ({
          '@type': 'Question',
          name: item.q,
          acceptedAnswer: { '@type': 'Answer', text: item.a },
        })),
      },
    ],
    [allFaq],
  );

  usePageMeta({
    title: '爆料大赛常见问题 - 赛程时间、报名投稿与评审规则解答',
    description:
      '爆料大赛常见问题汇总：赛程分为几个阶段、时间是否北京时间、截稿后能否补交、投票权重与刷票处理、获奖名单公示与申诉方式，共 13 个高频问题一次说清。',
    keywords: '爆料大赛赛程,爆料大赛日程,爆料大赛比赛进度,爆料大赛活动安排,爆料大赛时间表',
    path: '/faq',
    jsonLd,
  });

  return (
    <SiteLayout>
      <FaqHero />
      <FaqGroups />

      <section className="w-full px-4 md:px-6 pb-16 md:pb-24 bg-background-50">
        <div className="max-w-6xl mx-auto rounded-lg bg-secondary-950 px-6 md:px-10 py-8 md:py-10 flex flex-col md:flex-row md:items-center justify-between gap-6">
          <div>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-background-50">问题还没解决？</h2>
            <p className="mt-2 text-sm text-background-300">
              到关于我们页留下你的联系方式，我们会在两个工作日内回复与赛程相关的疑问。
            </p>
          </div>
          <Link
            to="/about"
            className="shrink-0 px-6 py-3 rounded-md bg-accent-500 text-secondary-950 text-sm font-medium whitespace-nowrap hover:bg-accent-400 transition-colors cursor-pointer"
          >
            联系我们
          </Link>
        </div>
      </section>
    </SiteLayout>
  );
}